import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const HourProgressCard = ({ summary }) => {
    if (!summary) {
        return (
            <div className="bg-white border border-gray-200 rounded-lg p-6 text-center">
                <p className="text-gray-600">No hour data available</p>
            </div>
        );
    }

    const progress = Number(summary.progress_percentage || 0);
    const remaining = Number(summary.remaining || 0);
    const approved = Number(summary.total_approved || 0);
    const required = Number(summary.total_required || 0);

    return (
        <div className="bg-white border border-gray-200 rounded-lg p-6">
            <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="w-32 h-32 flex-shrink-0">
                    <CircularProgressbar
                        value={progress}
                        text={`${Math.round(progress)}%`}
                        styles={buildStyles({
                            textColor: '#111111',
                            pathColor: '#111111',
                            trailColor: '#E8E8E8',
                            textSize: '1.2rem',
                            pathTransitionDuration: 0.5,
                        })}
                    />
                </div>

                <div className="flex-1 text-center md:text-left">
                    <h3 className="text-lg font-semibold text-gray-900">
                        Approved: {approved} / {required}
                    </h3>
                    <p className="text-gray-600 mt-1">
                        Remaining: {remaining} · Progress: {Math.round(progress)}%
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                        Only approved hours count toward completion.
                    </p>

                    <div className="grid grid-cols-2 gap-3 mt-4">
                        <div className="p-3 bg-gray-50 rounded-lg">
                            <p className="text-xs text-gray-500">Logged</p>
                            <p className="text-lg font-semibold text-gray-900">
                                {summary.total_logged || 0}
                            </p>
                        </div>
                        <div className="p-3 bg-gray-50 rounded-lg">
                            <p className="text-xs text-gray-500">Verified</p>
                            <p className="text-lg font-semibold text-gray-900">
                                {summary.total_verified || 0}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HourProgressCard;
